<template>
    <v-dialog v-model="dialog" width="500px">
        <!-- 有警示:警示區當頁首,關閉鈕整合在右上角(不另外顯示灰色橫條) -->
        <div v-if="alertData" style="position: relative;">
            <SafetyAlertBlock :alert="alertData" sheetClass="pr-12" @updated="onAlertUpdated"
                @update-failed="$emit('alert-update-failed')" />
            <v-btn icon small absolute top right style="top: 6px; right: 6px;" @click="dialog = false"
                class="normal-case">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </div>
        <v-sheet v-else color="grey lighten-3" class="text-right">

            <v-btn icon @click="dialog = false"
                class="normal-case">
                <v-icon>mdi-close</v-icon>
            </v-btn>
        </v-sheet>
        <Post class="post-in-dialog" v-bind:postItem="openedPostItem" v-bind:commentList="commentList"
            v-bind:homeworkId="homeworkId" v-bind:key="postId" />
    </v-dialog>
</template>

<script>
import Post from '@/components/console/diary/component/Post.vue'
import SafetyAlertBlock from '@/components/console/diary/component/SafetyAlertBlock.vue'
import { diaryPostServices } from '@/services/diaryPost.js';
import { safetyAlertServices } from '@/services/safetyAlert.js';
export default {
    name: "postDialog",
    components: { Post, SafetyAlertBlock },
    props: ['postId', 'homeworkId', 'postDialogOpenCount', 'safetyAlert'],
    data() {
        return {
            dialog: false,
            openedPostItem: {},
            commentList: [],
            fetchedAlert: null,
            fetchedAlertPostId: null,
        };
    },
    async created() {
        this.getDiaryPost();
    },
    watch: {
        async postDialogOpenCount() {
            this.getDiaryPost();
        },
    },
    computed: {
        /** 優先用父層傳入的 alert(省一次查詢);否則用自行查到的 */
        alertData() {
            return this.safetyAlert || this.fetchedAlert;
        },
    },
    mounted() {

    },
    methods: {
        async getDiaryPost() {
            this.loadSafetyAlert();
            if (this.postId == this.openedPostItem.diary_post_id) {
                this.dialog = true;
                return;
            }
            const postRes = await diaryPostServices.getHomeworkPost(this.postId);
            this.openedPostItem = postRes.data.post;
            this.commentList = postRes.data.comment;
            this.dialog = true;
        },
        /** 沒帶 safetyAlert prop 時依 postId 查警示(任何入口都會顯示) */
        async loadSafetyAlert() {
            if (this.safetyAlert || this.fetchedAlertPostId === this.postId) {
                return;
            }
            this.fetchedAlertPostId = this.postId;
            try {
                const res = await safetyAlertServices.getByPost(this.postId);
                this.fetchedAlert = res.data?.alert ?? null;
            } catch (err) {
                // 查警示失敗不影響日記瀏覽
                this.fetchedAlert = null;
            }
        },
        onAlertUpdated(status) {
            this.$emit('alert-updated', status);
        },
    },
};
</script>
<style scoped>
/* 彈窗本身已是外框,拿掉 Post 卡片的邊框/圓角/下邊距,
   讓警示區與日記內容看起來是同一塊,不會像兩張卡疊在一起 */
.post-in-dialog {
    border: none !important;
    border-radius: 0 !important;
    margin-bottom: 0 !important;
}
</style>
